




























































































import { Component, Vue, Watch } from 'vue-property-decorator'
import StatsTable from './StatsTable.vue'
import StatsRunTime from './StatsRunTime.vue'
import StatsStatisticsTable from './StatsStatisticsTable.vue'
import api from '../../api'
import { UserModule } from '../../store/modules/user'
import { IFormItem } from '../../components/PublicQuery/PublicQuery'
import { formatDate, setDateToStart } from '../../utils/utils'
import PublicQuery from '@/components/PublicQuery/PublicQuery.vue'
import echarts from 'echarts'
import Echarts from '@/components/Echarts/Echarts.vue'
import { UnitControlTypeMap } from '@/model/const'


@Component({
  components: {
    StatsTable,
    StatsRunTime,
    PublicQuery,
    Echarts,
    StatsStatisticsTable,
  },
})
export default class StatsData extends Vue {
  private noData: boolean = false
  private deviceStatsList: any[] = []
  private queryItems: IFormItem[] = [
    {
      label: '查询日期',
      key: 'date',
      type: 'date',
      placeholder: '选择查询日期',
      clearable: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
      },
    },
  ]
  private queryParams = {
    date: formatDate(new Date(), 'YYYY-MM-DD'),
    region: [],
  }

  private lastDay() {
    var datetTime = new Date(this.queryParams.date)
    const time = datetTime.setDate(datetTime.getDate() - 1)
    this.queryParams.date = this.formatDate1(time)
    this.getDevCounts()
  }

  private afterDay() {
    var datetTime = new Date(this.queryParams.date)
    const time = datetTime.setDate(datetTime.getDate() + 1)
    if (time > Date.now()) {
      this.$message.warning('只能查询今天之前的记录')
      return
    }
    this.queryParams.date = this.formatDate1(time)
    this.getDevCounts()
  }

  private reflesh() {
    this.getDevCounts()
  }

  private formatDate1(time : any) {
    const t = new Date(time)
    // 日期格式
    let year:any = t.getFullYear()
    // 由于 getMonth 返回值会比正常月份小 1
    let month:any = t.getMonth() + 1
    let day:any = t.getDate()
    month = month > 9 ? month : `0${month}`
    day = day > 9 ? day : `0${day}`
    return year + '-' + month + '-' + day
  }

  private option: any = {}
  mounted() {
    this.getDeviceStatsList()
    this.queryChange()
  }
  private queryChange() {
    this.getDevCounts()
  }
  private getDevCounts() {
    const { date = '', region = [] } = this.queryParams
    if (!date) {
      this.$message.warning('请选择查询日期')
      return
    }
    const orgId = UserModule.orgInfo.orgId
    const orgName = UserModule.orgInfo.name
    api.getDevCounts({ orgId, date }).then((params) => {
      // console.log('data' + JSON.stringify(params))
      const { 空调在线数量 = [], 空调全部数量 = [], 开关在线数量 = [], 开关全部数量 = [], 其他设备在线数量 = [], 其他设备全部数量 = [] }: { 空调在线数量: any[], 空调全部数量: any[], 开关在线数量: any[], 开关全部数量: any[], 其他设备全部数量: any[], 其他设备在线数量: any[]} = params || {}
      this.noData = !空调在线数量.length && !空调全部数量.length && !开关在线数量.length && !开关全部数量.length && !其他设备在线数量.length && !其他设备全部数量.length
      // console.log('空调次数' + JSON.stringify(空调在线数量))
      var length:any = Object.keys(params).length
      // console.log('次数' + length)
      if (this.noData) return
      const minTime: any = new Date(this.queryParams.date).setHours(0, 0, 0)
      const maxTime: any = new Date(this.queryParams.date).setHours(23, 59, 59)
      this.option = {
        title: {
          textStyle: {
            color: '#333',
            fontStyle: 'normal',
            fontWeight: '200',
            fontFamily: 'sans-serif',
            fontSize: 15,
          },
          text: date + '日' + orgName + '设备在线数量统计曲线图',
          x: 'center',
          y: 'bottom',
          padding: [100, 0, 0, 0],
        },
        tooltip: {
          trigger: 'axis',
          formatter: function(params: any[]) {
            let result = ''
            result += params.reduceRight((prev, curr, index) => {
              if (index === params.length - 1) {
                prev += `${formatDate(curr.axisValue)}<br>`
              }
              // console.log('curr' + JSON.stringify(curr))
              const r = prev += `${curr.marker}${curr.seriesName} ${curr.value[1]}<br>`
              return r
            }, result)
            return result
          },
        },
        legend: {
          data: ['空调在线数量', '空调全部数量', '开关在线数量', '开关全部数量', '其他设备在线数量', '其他设备全部数量'],
          itemHeight: 10, // 改变圆圈大小
          icon: 'circle',
          textStyle: {
            fontSize: 14,
          },
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '10%',
          containLabel: true,
        },
        toolbox: {
          feature: {
            dataZoom: {
              yAxisIndex: 'none',
            },
            restore: {},
            saveAsImage: {
              name: '单元分析',
            },
          },
        },
        dataZoom: [
          {
            type: 'inside',
            filterMode: 'none',
            throttle: 50,
          },
        ],
        xAxis: {
          type: 'time',
          splitNumber: 24,
          boundaryGap: true,
          min: minTime,
          max: maxTime,
          splitLine: { // 网格线
            show: false,
          },
          axisLabel: {
            formatter: function(value: any, index: number) {
              // 格式化成月/日，只在第一个刻度显示年份
              if (value % 3600000) {
                return formatDate(value, 'HH:mm:ss')
              } else {
                return formatDate(value, 'HH:mm')
              }
            },
          },
        },
        yAxis: {
          type: 'value',
          name: '数量/个',
          axisLabel: {
            formatter: '{value}',
            // color: '#27719F',
          },
        },
        series: [
          {
            name: '空调在线数量',
            type: 'line',
            step: 'start',
            data: this.getCountsLogData(空调在线数量),
            symbolSize: 1,
          },
          // {
          //   name: '空调全部数量',
          //   type: 'line',
          //   data: this.getCountsLogData(空调全部数量),
          //   symbolSize: 0,
          // },
          {
            name: '开关在线数量',
            type: 'line',
            data: this.getCountsLogData(开关在线数量),
            symbolSize: 1,
          },
          // {
          //   name: '开关全部数量',
          //   type: 'line',
          //   data: this.getCountsLogData(开关全部数量),
          //   symbolSize: 0,
          // },
          {
            name: '其他设备在线数量',
            type: 'line',
            data: this.getCountsLogData(其他设备在线数量),
            symbolSize: 1,
          },
          // {
          //   name: '其他设备全部数量',
          //   type: 'line',
          //   data: this.getCountsLogData(其他设备全部数量),
          //   symbolSize: 0,
          // },
        ],
      }
    })
  }
  private getCountsLogData(logs: any[]) {
    let logResult = logs.map((item: any) => [item.time, item.count, item])
    return logResult
  }
  private getDeviceStatsList() {
    const orgId = UserModule.orgInfo.orgId
    Promise.all([
      api.getDeviceInfo({ orgId }),
      api.getDeviceCountTime({ orgId }),
      api.getDeviceAverageTime({ orgId }),
    ]).then(([deviceInfo, deviceTime, deviceAvgTime]) => {
      const { devCount = [], devOnlineCount = [] } = deviceInfo || {}
      const { monthSum = [], weekSum = [], yearSum = [] } = deviceTime || {}
      const { monthDayAvg = [], weekDayAvg = [], yearDayAvg = [] } =
        deviceAvgTime || {}
      const typeStrObj: any = {
        air: '空调',
        switch: '灯光',
        other: '其他(插座及低功耗设备)',
      }
      const deviceNumList = Object.entries(typeStrObj).map(([key, value]) => {
        const devCountInfo =
          devCount.find((_: any) => _.devType === key) || {}
        const onlineInfo =
          devOnlineCount.find((_: any) => _.devType === key) || {}
        return {
          title: value + '数',
          content: [
            { label: '开启数', value: onlineInfo.size || 0 },
            { label: '总数量', value: devCountInfo.size || 0 },
          ],
        }
      })

      const deviceTimeList = Object.entries(typeStrObj).map(([key, value]) => {
        const weekInfo =
          weekSum.find((_: any) => _.devType === key) || {}
        const monthInfo =
          monthSum.find((_: any) => _.devType === key) || {}
        const yearInfo =
          yearSum.find((_: any) => _.devType === key) || {}
        return {
          title: value + '总运行时间(h)',
          content: [
            { label: '本周', value: weekInfo.runtime || 0 },
            { label: '本月', value: monthInfo.runtime || 0 },
            { label: '本年', value: yearInfo.runtime || 0 },
          ],
        }
      })
      const deviceAvgTimeList = Object.entries(typeStrObj).map(([key, value]) => {
        const weekInfo =
          weekDayAvg.find((_: any) => _.devType === key) || {}
        const monthInfo =
          monthDayAvg.find((_: any) => _.devType === key) || {}
        const yearInfo =
          yearDayAvg.find((_: any) => _.devType === key) || {}
        return {
          title: value + '日平均运行时间(h)',
          content: [
            { label: '上周', value: weekInfo.runtime || 0 },
            { label: '上月', value: monthInfo.runtime || 0 },
            { label: '上年', value: yearInfo.runtime || 0 },
          ],
        }
      })
      this.deviceStatsList = this.deviceStatsList.concat(
        deviceNumList,
        deviceTimeList,
        deviceAvgTimeList
      )
    })
  }
}
